var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.markets && _vm.markets.length
    ? _c(
        "div",
        { staticClass: "alt-markets coupon" },
        _vm._l(_vm.groupAltMarkets, function(
          altMarketGroup,
          altMarketGroupName
        ) {
          return _c(
            "div",
            { key: altMarketGroupName },
            [
              _c("h4", { staticClass: "event-market-header date" }, [
                _c(
                  "span",
                  {
                    staticClass: "market-name",
                    class: {
                      "expanded-market":
                        _vm.expandedAltMarketGroups[altMarketGroupName]
                    },
                    on: {
                      click: function($event) {
                        return _vm.toggleAltMarketGroupExpansion(
                          altMarketGroupName
                        )
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "market-name-title" }, [
                      _vm._v(_vm._s(altMarketGroupName))
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "flex icon-span" },
                      [
                        _c("sgp-tag", {
                          attrs: {
                            markets: _vm.getSGMProcessedMarkets(
                              altMarketGroup.markets
                            ),
                            isLive: _vm.isLiveEventPage
                          }
                        }),
                        _vm._v(" "),
                        _vm.isBBenabled &&
                        _vm.isMarketEligibleForBB(altMarketGroup.markets)
                          ? _c("span", { staticClass: "available-for-bb" })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.expandedAltMarketGroups[altMarketGroupName]
                          ? _c("v-icon", [_vm._v("expand_more")])
                          : _c("v-icon", [_vm._v("expand_less")])
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              (_vm.expandedAltMarketGroups[altMarketGroupName] &&
                altMarketGroup.markets[0].selections.filter(function(sel) {
                  return sel.hadvalue === "A"
                }).length > 0) ||
              (_vm.expandedAltMarketGroups[altMarketGroupName] &&
                altMarketGroup.markets[0].selections.filter(function(sel) {
                  return sel.hadvalue === "H"
                }).length > 0)
                ? _c("div", { staticClass: "alt-handicaps-header" }, [
                    _c("span", { staticClass: "alt-handicaps-header-name" }, [
                      _vm._v(_vm._s(_vm.event.participantname_home))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "alt-handicaps-header-name" }, [
                      _vm._v(_vm._s(_vm.event.participantname_away))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.expandedAltMarketGroups[altMarketGroupName]
                ? _c("markets", {
                    attrs: {
                      markets: _vm.getVisibleAltMarkets(
                        altMarketGroup.markets,
                        altMarketGroupName
                      ),
                      isAlternativeMarket: true,
                      event: _vm.event,
                      diplayOnPage: "live-single-event",
                      isLiveEventPage: _vm.isLiveEventPage,
                      pricechangehighlight: _vm.isLiveEventPage
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.altMarketSelectionsCountByGroup[altMarketGroupName] > 6 &&
              _vm.expandedAltMarketGroups[altMarketGroupName]
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "show-more-btn" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { ripple: false, flat: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.toggleAltMarketSelectionsVisibility(
                                  altMarketGroupName
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.expandedAltMarketSelections[
                                      altMarketGroupName
                                    ],
                                    expression:
                                      "!expandedAltMarketSelections[altMarketGroupName]"
                                  }
                                ]
                              },
                              [_vm._v(_vm._s(_vm.$t("BettingOffer.SeeMore")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.expandedAltMarketSelections[
                                        altMarketGroupName
                                      ],
                                    expression:
                                      "expandedAltMarketSelections[altMarketGroupName]"
                                  }
                                ]
                              },
                              [_vm._v(_vm._s(_vm.$t("BettingOffer.SeeLess")))]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-619f9800", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-619f9800","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/AltMarkets.vue
// module id = null
// module chunks = 